export const Pages = Object.freeze({
  SIGN_IN: '/sign-in',
  ACCESS_DENIED: '/access-denied',
});
